var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center pt-6 mt-auto min-h-4"},[_c('p',{staticClass:"text-base text-black font-medium mr-4"},[_vm._v("Secured By")]),_c('fluidcoins',{staticClass:"w-8 h-8"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }